import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { RiCloseLine } from 'react-icons/ri';

export default function FilterButton({
  value,
  isApplied,
  isClosable,
  onClick,
  ...rest
}) {
  return (
    <button
      key={value.key}
      type="button"
      onClick={onClick}
      className={clsx(
        'm-0 flex items-center rounded-full border border-solid py-2.5 px-3 text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-deep-blue focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-xs',
        {
          'border-deep-blue bg-deep-blue text-white': isApplied,
          'border-gray bg-transparent text-black': !isApplied
        }
      )}
      {...rest}
    >
      <span>
        {value.name} ({value.count})
      </span>
      {isClosable && isApplied && <RiCloseLine className="ml-2 h-4 w-4" />}
    </button>
  );
}

FilterButton.propTypes = {
  /**
   * The Value of the Filter.
   */
  value: PropTypes.shape({
    /**
     * The Label of the Filter.
     */
    name: PropTypes.string.isRequired,
    /**
     * The Number of Products that match the Filter.
     */
    count: PropTypes.number.isRequired
  }).isRequired,
  /**
   * Whether the Filter is currently applied or not.
   */
  isApplied: PropTypes.bool,
  /**
   * Whether the Remove Icon should be displayed or not.
   */
  isClosable: PropTypes.bool,
  /**
   * The Function to call when the Filter is clicked.
   */
  onClick: PropTypes.func.isRequired
};

FilterButton.defaultProps = {
  isApplied: false,
  isClosable: false
};
